import PropTypes from 'prop-types';
import React from 'react';

import VideoMediaFile from './VideoMediaFile';
import ImageMediaFile from './ImageMediaFile';

const cardMediaCarouselFileDefaultPropAnalytics = {};
const cardMediaCarouselFileDefaultPropMuxVideoProps = {};
/** @param {Record<string, any>} props */
export default function CardMediaCarouselFile({
  mediaFile,
  smartImageProps,
  muxVideoProps = cardMediaCarouselFileDefaultPropMuxVideoProps,
  badgeProps = null,
  analytics = cardMediaCarouselFileDefaultPropAnalytics,
  muxRef = null,
  carouselPosition = null,
  ...rest
}) {
  const props = { badgeProps, analytics, muxRef, carouselPosition, ...rest };
  if (mediaFile.type === 'Video') {
    const { style, ...videoProps } = muxVideoProps;

    const videoStyle = {
      width: smartImageProps.width,
      height: smartImageProps.height,
      ...style
    };

    return (
      <VideoMediaFile
        {...props}
        mediaFile={mediaFile}
        videoProps={{ ...videoProps, style: videoStyle }}
      />
    );
  }

  return (
    <ImageMediaFile
      smartImageProps={smartImageProps}
      mediaFile={mediaFile}
      {...props}
    />
  );
}

CardMediaCarouselFile.propTypes = {
  mediaFile: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    analytics: PropTypes.shape({
      view: PropTypes.string.isRequired,
      view_feature: PropTypes.string.isRequired,
      view_feature_location: PropTypes.string.isRequired
    }),
    url: PropTypes.string,
    alt: PropTypes.string,
    experiment_clickthrough_url: PropTypes.string,
    playback_ids: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        policy: PropTypes.string.isRequired
      })
    ),
    status: PropTypes.string,
    aspect_ratio: PropTypes.string,
    type: PropTypes.string,
    puppy_id: PropTypes.number
  }).isRequired,
  analytics: PropTypes.shape({
    availability: PropTypes.string,
    breed_id: PropTypes.number,
    breeder_profile_id: PropTypes.number,
    position: PropTypes.number,
    view: PropTypes.string.isRequired,
    view_feature: PropTypes.string,
    view_feature_location: PropTypes.string.isRequired
  }),
  // eslint-disable-next-line react/forbid-prop-types
  smartImageProps: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types,
  muxVideoProps: PropTypes.object,
  muxRef: PropTypes.shape({ current: PropTypes.node }),
  badgeProps: PropTypes.shape({
    text: PropTypes.string.isRequired,
    position: PropTypes.string
  }),
  carouselPosition: PropTypes.number
};
